import Axios from "axios";

const axios = Axios.create({
  withCredentials: true,
  headers: {
    Accept: "application/json; charset=utf-8",
    "Content-Type": "application/json; charset=utf-8",
  },
});

export default axios;
